import { useState, useEffect } from 'react';
import axios from 'axios';

const useLeagueData = (leagueId) => {
  const [leagueData, setLeagueData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLeagueData = async () => {
      try {
        console.log('Fetching league data for leagueId:', leagueId);
        setLoading(true);
		console.log('Wysyłam żądanie do /api/competitions');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/competitions`);
        const competitions = response.data;

        console.log('Competitions data:', competitions);

        let foundLeague = null;
        Object.keys(competitions).forEach(level => {
          const league = competitions[level].find(comp => comp.competition_id === parseInt(leagueId));
          if (league) {
            foundLeague = league;
          }
        });

        if (foundLeague) {
          setLeagueData(foundLeague);
          console.log('Found league:', foundLeague);
        } else {
          setError('Liga nie została znaleziona.');
          console.log('League not found for leagueId:', leagueId);
        }
      } catch (err) {
        setError('Błąd podczas pobierania danych ligi: ' + err.message);
        console.error('Error fetching league data:', err);
      } finally {
        setLoading(false);
        console.log('Finished fetching league data, loading:', false);
      }
    };

    if (leagueId) {
      fetchLeagueData();
    } else {
      console.log('No leagueId provided, skipping fetch');
      setLoading(false);
    }
  }, [leagueId]);

  return { leagueData, loading, error };
};

export default useLeagueData;